import { render, staticRenderFns } from "./AddYourCompany.vue?vue&type=template&id=4b58565a&scoped=true&"
import script from "./AddYourCompany.vue?vue&type=script&lang=js&"
export * from "./AddYourCompany.vue?vue&type=script&lang=js&"
import style0 from "./AddYourCompany.vue?vue&type=style&index=0&id=4b58565a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58565a",
  null
  
)

export default component.exports